export default __webpack_public_path__ + "static/media/fb.9df789e9.svg";